import styled from '@emotion/styled'

export const EmptyStateImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  min-height: 0;
`

export const InnerContainer = styled.div`
  display: flex;
  justify-content: center;
  min-height: inherit;
`
